import { BaseWebComponentView } from '../../../framework/BaseWebComponentView';
import { toggleVisibility } from '../../../utils/htmlElement.utils';
import { TemplateState } from '../../../types/common/types';
import { GzButtonWebComponent } from '../../../ui/gzButton';
import { MobileSecurityAccountStatus, MobileSecurityCompanyRecord } from '../../mobileSecurityCompanyGrid/types';
import { GzTooltipWebComponent } from '../../../ui/gzTooltip';
import { GzTextWebComponent } from '../../../ui/gzText';
import { getExpiredTooltipText } from '../../mobileSecurityCompanyGrid/view/customGridRenderers';

export class MobileSecurityCustomerViewView extends BaseWebComponentView {
  dom: {
    $wrapper: HTMLElement;

    $noAccountWrapper: HTMLElement;
    $withAccountWrapper: HTMLElement;

    $createAccountText: GzTextWebComponent;
    $openConsoleText: GzTextWebComponent;
    $sendEmailsText: GzTextWebComponent;

    $createAccountButton: GzButtonWebComponent;
    $openConsoleButton: GzButtonWebComponent;
    $sendEmailsButton: GzButtonWebComponent;

    $createAccountTooltip: GzTooltipWebComponent;
    $expiredAccountTooltip: HTMLElement;
    $expiredAccountTooltipText: HTMLElement;
  };

  getDomElements() {
    this.dom = {
      $wrapper: this.shadow.querySelector('.wrapper'),

      $noAccountWrapper: this.shadow.querySelector('#no-account'),
      $withAccountWrapper: this.shadow.querySelector('#with-account'),

      $createAccountText: this.shadow.querySelector('#create-text'),
      $openConsoleText: this.shadow.querySelector('#console-text'),
      $sendEmailsText: this.shadow.querySelector('#invitation-text'),

      $createAccountButton: this.shadow.querySelector('#create-button'),
      $openConsoleButton: this.shadow.querySelector('#console-button'),
      $sendEmailsButton: this.shadow.querySelector('#invitation-button'),

      $createAccountTooltip: this.shadow.querySelector('#create-tooltip'),
      $expiredAccountTooltip: this.shadow.querySelector('#expired-tooltip'),
      $expiredAccountTooltipText: this.shadow.querySelector('#expired-tooltip-text'),
    };

    this.setLoadingState();
    this.getTranslations();
    this.setTranslatedStrings();
  }

  getTranslations() {
    this.commonStrings = this.stringsTranslator.getCommonStrings();
    this.translations = this.stringsTranslator.getMobileSecurityStrings();
  }

  public setTranslatedStrings() {
    this.dom.$createAccountText.innerText = this.translations.createAccountText;
    this.dom.$openConsoleText.innerText = this.translations.openConsoleText;
    this.dom.$sendEmailsText.innerText = this.translations.sendActivationLinksText;

    this.dom.$createAccountButton.innerText = this.translations.createAccount;
    this.dom.$openConsoleButton.innerText = this.translations.openConsole;
    this.dom.$sendEmailsButton.innerText = this.translations.sendActivationLinks;
  }

  setLoadingState() {
    this.resetTemplateState(this.dom.$wrapper);
    this.setTemplateState(this.dom.$wrapper, TemplateState.LOADING);
  }

  removeLoadingState() {
    this.resetTemplateState(this.dom.$wrapper);
  }

  async buildSuccessView(company: MobileSecurityCompanyRecord | undefined) {
    toggleVisibility(this.dom.$noAccountWrapper, false);
    toggleVisibility(this.dom.$withAccountWrapper, false);
    toggleVisibility(this.dom.$expiredAccountTooltip, false);
    this.dom.$createAccountTooltip.tooltipText = '';
    this.dom.$openConsoleButton.disabled = false;
    this.dom.$sendEmailsButton.disabled = false;
    this.dom.$createAccountButton.disabled = false;

    if (company === undefined) {
      toggleVisibility(this.dom.$noAccountWrapper, true);
      this.dom.$createAccountButton.disabled = true;
      this.dom.$createAccountTooltip.tooltipText = this.translations.licenseNotValid;
    } else {
      switch (company.accountStatus) {
        case MobileSecurityAccountStatus.NOT_CREATED:
          toggleVisibility(this.dom.$noAccountWrapper, true);
          break;

        case MobileSecurityAccountStatus.CREATED:
          toggleVisibility(this.dom.$withAccountWrapper, true);
          toggleVisibility(this.dom.$expiredAccountTooltip, false);
          break;

        case MobileSecurityAccountStatus.EXPIRED:
          toggleVisibility(this.dom.$withAccountWrapper, true);
          toggleVisibility(this.dom.$expiredAccountTooltip, true);
          this.dom.$openConsoleButton.disabled = true;
          this.dom.$sendEmailsButton.disabled = true;
          this.dom.$expiredAccountTooltipText.innerText = getExpiredTooltipText(this.translations, company.daysUntilExpire);
      }
    }

    this.removeLoadingState();
  }

  buildErrorView(error: Error) {
    console.error(error);
    this.resetTemplateState(this.dom.$wrapper);
    this.setTemplateState(this.dom.$wrapper, TemplateState.ERROR);
  }
}
